import "./App.css"
import { Route, HashRouter, Routes } from "react-router-dom"
// import Notice from "./pages/Notice"
// import NZ from "./pages/NZ"
import TAIWAN_MARTIN from "./pages/taiwan_martin"

const App = () => {
  return (
    <HashRouter>
      <Routes>
        {/* <Route path="/nz/:uid" element={<NZ />} /> */}
        <Route path="/525/:uid" element={<TAIWAN_MARTIN />} />
        {/* <Route path='/notice' element={<Notice />} /> */}
      </Routes>
    </HashRouter>
  );
}

export default App;
